/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  UpdateSessionMutationRequest,
  UpdateSessionMutationResponse,
  UpdateSessionPathParams,
  UpdateSession400,
  UpdateSession401,
  UpdateSession403,
  UpdateSession404,
} from '../types/UpdateSession.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getUpdateSessionUrl(id: UpdateSessionPathParams['id']) {
  const res = { method: 'PUT', url: `/sessions/${id}` as const };
  return res;
}

/**
 * @summary Update session
 * {@link /sessions/:id}
 */
export async function updateSession(
  id: UpdateSessionPathParams['id'],
  data: UpdateSessionMutationRequest,
  config: Partial<RequestConfig<UpdateSessionMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UpdateSessionMutationResponse,
    ResponseErrorConfig<UpdateSession400 | UpdateSession401 | UpdateSession403 | UpdateSession404>,
    UpdateSessionMutationRequest
  >({ method: 'PUT', url: getUpdateSessionUrl(id).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
